<section class="hero">
    <div class="inner">
        <img
            src="/../../../../../assets/images/collections/secinj.png"
            alt="Security Injections Logo"
            class="logo" />
        <h1 class="title">Security Injections</h1>
        <div class="buttons">
            <button
                class="button neutral"
                aria-label="Browse Collection"
                (activate)="navigateToBrowse()">
                Browse Collection
            </button>
        </div>
    </div>
</section>
